import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { ScannerService } from '../../services/connectors/scanner.service';
import { ConnectorConfig } from '../../services/connectors/storage.types';

@Component({
  selector: 'app-connector-status',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './connector-status.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./connector-status.component.scss'],
})
export class ConnectorStatusComponent implements OnInit {
  connectorIds: string[] = [];
  connectors: Map<string, ConnectorConfig> = new Map();
  loading = true;
  error = '';
  
  private scanner = inject(ScannerService);
  private router = inject(Router);

  async ngOnInit() {
    try {
      this.loading = true;
      this.connectorIds = await this.scanner.listConfiguredConnectors();
      
      // Load details for each connector
      for (const id of this.connectorIds) {
        try {
          const config = await this.scanner.loadConnectorCredentials(id);
          if (config) {
            this.connectors.set(id, config as any);
          }
        } catch (e) {
          console.warn(`Failed to load connector ${id}:`, e);
        }
      }
    } catch (e: any) {
      this.error = e instanceof Error ? e.message : 'Failed to load connectors';
    } finally {
      this.loading = false;
    }
  }

  getConnectorConfig(id: string): ConnectorConfig | undefined {
    return this.connectors.get(id);
  }

  getVendorIcon(vendor: string): string {
    switch (vendor) {
      case 'tenable':
        return '🔒';
      case 'rapid7':
        return '⚡';
      default:
        return '🔧';
    }
  }

  async deleteConnector(id: string) {
    if (!confirm('Are you sure you want to delete this connector? This action cannot be undone.')) {
      return;
    }

    try {
      await this.scanner.deleteConnector(id);
      this.connectorIds = this.connectorIds.filter(cid => cid !== id);
      this.connectors.delete(id);
    } catch (e: any) {
      this.error = `Failed to delete connector: ${e instanceof Error ? e.message : 'Unknown error'}`;
    }
  }

  addConnector() {
    this.router.navigate(['/setup/connectors']);
  }

  goToDashboard() {
    this.router.navigate(['/admin/dashboard']);
  }
}
